import { format, parseISO } from "date-fns"


export default function getYear(date) {
  const stringDate = parseISO(date);
  const formattedYear = format(stringDate, "yyyy");
  return formattedYear;
}